module.exports = __webpack_public_path__ + "media/images/logo-odakyu_pro-fada79bf.png";